import React, { useState, useRef, useEffect } from 'react';
import Autocomplete from 'react-google-autocomplete'
import { setAddressSearch } from '../../../redux-files/actions/action'
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from '../../../helpers/helpers';
import CONSTANTS from '../../../Constants';
import { pushEventToGTM } from '../../../helpers/trackerManager';

const DealerSearch = ({ onCloseDealersMap, onDealerSearch }) => {
    const addressSearchInput = useRef()
    const captionText = useRef()
    const dispatch = useDispatch()
    const addressSearch = useSelector(state => state.ndel_store.addressSearch)
    const [selectedaddress, setSelectedaddress] = useState(
        {
            address: addressSearch.address,
            lat: null,
            lng: null
        },
    )
    useEffect(()=>{
        captionText.current.scrollIntoView({ behavior: 'smooth' })
    },[])
    const getGeoaddressFromSearchInput = (inputRef) => {
        if (inputRef) {
            const geocoder = new window.google.maps.Geocoder()
            geocoder.geocode({
                address: inputRef.current.value,
                componentRestrictions: {
                    country: window.siteConfig.currentCountry
                }
            }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        onDealerSearch({
                            address: results[0].formatted_address,
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng()
                        })
                        dispatch(setAddressSearch(
                            {
                                address: results[0].formatted_address,
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng()
                            }))

                    } else {
                        console.log('No results found')
                    }
                } else {
                    console.error(new Error('Geocoder failed due to: ' + status))
                }
            })
            pushEventToGTM({
                pageName: 'dealer locator',
                eventAction: 'Redirection::Search::Dealer',
                eventLabel: inputRef.current.value,
                eventCategory: 'Dealerlocator'
            })
          }
    }
    return (
        <div className='dealerDetails dealerSearch'>
            <div className='dealerBlock-title'>
                <span>{CONSTANTS.LABELS.header_quote_dealer}</span>
                {isMobile() && <span onClick={onCloseDealersMap} className='close'></span>}
            </div>
            <div ref={captionText} className='dealerBlock-searchCaption'>
                <label for="position">{CONSTANTS.LABELS.dealer_locator_quote_subtitle}</label>
            </div>
            <div className='dealerBlock-search'>
                <Autocomplete
                    id='position'
                    placeholder={CONSTANTS.LABELS.dealer_locator_searchlabel}
                    className='form-elements form--input-text'
                    onChange={(e) =>
                        setSelectedaddress({
                            ...selectedaddress,
                            address: e.target.value
                        })
                    }
                    onKeyPress={e => {
                        if (e.key === 'Enter') getGeoaddressFromSearchInput(addressSearchInput)
                    }}
                    ref={addressSearchInput}
                    value={selectedaddress.address}
                    onPlaceSelected={(place) => {
                        if (place.hasOwnProperty('id')) {
                            setSelectedaddress({
                                address: place.formatted_address,
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng()
                            })
                        }
                    }}
                    options={{
                        types: ["(regions)"],
                        componentRestrictions: { country: window.siteConfig.currentCountry },
                    }}
                />
                <button
                    type='button' className='search-button'
                    onClick={() => getGeoaddressFromSearchInput(addressSearchInput)
                    }
                >
                    <span>{CONSTANTS.LABELS.dealer_locator_searchcta}</span>
                </button>
            </div>



        </div>
    );

}

export default DealerSearch;